<p class="text-title-lgx-bold" *ngIf="showTitle">Plan</p>
<p class="text-info-bold-xs mt-xxs" *ngIf="showTitle">¿CÓMO DESEAS UNIRTE A LA PLATAFORMA?</p>

<nz-alert nzType="info"
  *ngIf="!inBilling"
  class="tw-w-full mt-xs"
  [nzMessage]="alertMessage" nzShowIcon></nz-alert>
<div class="plans mt-sm" nz-row [nzGutter]="[15, 15]">
  <div *ngIf="plans && plans.length> 0" nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="widthFull ? 24 : 12">
    <ng-container *ngFor="let plan of plans">
      <div *ngIf="(!(billingInfo$ | async)?.subscription?.isBeta) && timeSelected === (plan.interval === 'year')" class="plans-container mb-sm" (click)="onSelectedPlan(plan)">
        <div class="plan cursor-pointer" [class.active]="planSelectedId === plan._id" (click)="selectPlanId(plan._id)">
          <div class="d-flex align-items-center">
            <div class="plan-check mr-xs" [class.checked]="planSelectedId === plan._id">
              <i *ngIf="planSelectedId === plan._id" @fadeInAnimation nz-icon nzType="check" nzTheme="outline"></i>
            </div>
            <div class="plan-name">
              <p>{{ plan.product ? plan.product.name : 'nombre del plan' }}</p>
              <span *ngIf="!inBilling">{{30}} días gratis</span>
            </div>
          </div>
          <div class="plan-price">
            <p>${{ plan.amount}} {{plan.currency}} <span> / {{plan.interval === 'year' ? 'año' : 'mes'}}</span></p>
          </div>
        </div>
      </div>
      <div *ngIf="(billingInfo$ | async)?.subscription?.isBeta && planSelectedId === plan._id" class="plans-container mb-sm" >
        <div class="plan cursor-pointer" [class.active]="planSelectedId === plan._id" (click)="selectPlanId(plan._id)">
          <div class="d-flex align-items-center">
            <div class="plan-check mr-xs" [class.checked]="planSelectedId === plan._id">
              <i *ngIf="planSelectedId === plan._id" @fadeInAnimation nz-icon nzType="check" nzTheme="outline"></i>
            </div>
            <div class="plan-name">
              <p>{{ plan.product ? plan.product.name : 'nombre del plan' }}</p>
              <span *ngIf="!inBilling">{{30}} días gratis</span>
            </div>
          </div>
          <div class="plan-price">
            <p>$0 {{plan.currency}} <span> / {{plan.interval === 'year' ? 'año' : 'mes'}}</span></p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="widthFull ? 24 : 12">
    <div class="plan-details">
      <div class="d-flex justify-content-between align-items-center mb-sm">
        <p class="details-title">INCLUYE</p>
        <div class="plan-time" *ngIf="!(billingInfo$ | async)?.subscription?.isBeta">
          <div class="time" [class.active]="!timeSelected" @fadeInAnimation (click)="onChangeTimePlanSelected(false)">MENSUAL</div>
          <div class="time" [class.active]="timeSelected" @fadeInAnimation (click)="onChangeTimePlanSelected(true)">ANUAL</div>
        </div>
      </div>
      <div class="module" *ngIf="planDtoSelected?.product?.metadata?.branch">
        <i nz-icon class="mr-xxs" [nzType]="'check-circle'" nzTheme="fill"></i>
        Registro de {{ planDtoSelected.product.metadata.branch }} sucursal{{ planDtoSelected.product.metadata.branch > 1 ? 'es' : '' }}
      </div>
      <div class="module" *ngIf="planDtoSelected?.product?.metadata?.expert">
        <i nz-icon class="mr-xxs" [nzType]="'check-circle'" nzTheme="fill"></i>
        Registro de {{ planDtoSelected.product.metadata.expert }} experto{{ planDtoSelected.product.metadata.expert > 1 ? 's' : '' }}
      </div>
      <div class="module" *ngIf="planDtoSelected?.product?.metadata?.patient">
        <i nz-icon class="mr-xxs" [nzType]="'check-circle'" nzTheme="fill"></i>
        Registro de {{ planDtoSelected.product.metadata.patient }} paciente{{ planDtoSelected.product.metadata.patient > 1 ? 's' : '' }}
      </div>
      <p class="text-info mt-xlg" *ngIf="!planDtoSelected">No se ha seleccionado ningún plan</p>
    </div>
  </div>
</div>
